import { defineStore } from 'pinia'
import type { LocalNotificationBaseNonGeneric } from '@/services/InAppNotificationService'

function genhash(n: LocalNotificationBaseNonGeneric): string {
  const obj = {
    t: n.type,
    d: n.data,
    e: n.employee
  }
  const str = JSON.stringify(obj)
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0
  }
  return (hash >>> 0).toString(36)
}

export const useLocalNotificationStore = defineStore('local-notification-store', {
  state: (): { $data: Record<string, LocalNotificationBaseNonGeneric> } => ({
    $data: {}
  }),
  persist: true,
  actions: {
    GetNotifications(): LocalNotificationBaseNonGeneric[] {
      return Object.values(this.$data)
    },
    Add(notification: LocalNotificationBaseNonGeneric) {
      const hash = genhash(notification)
      if (!(hash in this.$data)) this.$data[hash] = notification
    },
    Remove(notification: LocalNotificationBaseNonGeneric) {
      const hash = genhash(notification)
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.$data[hash]
    }
  }
})
